<template>
  <div class="pagination-component">
    <button
      class="back"
      :style="{ backgroundColor: $store.registratorBackgroundBtnColor }"
      :disabled="value - 1 === 0"
      @click="changePage(value - 1)"
    >
      <ArrowIcon :direction="'left'" />
    </button>
    <div
      v-for="paginationItem in paginationItems"
      :key="paginationItem"
      class="pagination-item"
      :class="{
        'pagination-item_selected': value === paginationItem
      }"
      :style="{ color: value === paginationItem ? $store.registrator_text_btn : $store.registratorBackgroundBtnColor }"
      @click="changePage(paginationItem)"
    >
      {{ paginationItem }}
    </div>
    <button
      class="next"
      :style="{ backgroundColor: $store.registratorBackgroundBtnColor }"
      :disabled="value === pagesCount"
      @click="changePage(value + 1)"
    >
      <ArrowIcon :direction="'right'" />
    </button>
  </div>
</template>

<script>
import ArrowIcon from './Icons/Arrow';

export default {
  name: 'Pagination',
  components: {
    ArrowIcon
  },
  props: {
    pagesCount: {
      type: Number,
      default: 0
    },
    value: {
      type: Number,
      default: 1
    }
  },
  computed: {
    paginationItems() {
      return new Array(this.pagesCount).fill().map((_, i) => i + 1);
    }
  },
  methods: {
    changePage(page) {
      this.$emit('changePage', page);
    }
  }
}
</script>

<style lang="scss" scoped>
.pagination-component {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;

  & > *:not(:first-child) {
    margin-left: 1.25vw;
  }

  button {
    width: min(7.8125vh, 80px);
    height: min(7.8125vh, 80px);
    border-radius: 50%;
    background: #ffffff;
    box-shadow: 0px 33px 38px rgba(0, 0, 0, 0.0314074), 0px 12px 12px rgba(0, 0, 0, 0.05), 0px 3px 3px rgba(0, 0, 0, 0.08);
    border: none;
    outline: none;

    svg {
      width: 52.5%;
      height: auto;
    }

    &:disabled {
      background: rgba(60, 60, 67, 0.18) !important;
      box-shadow: none;

      svg {
        fill: rgba(60, 60, 67, 0.18);
      }
    }
  }

  .pagination-item {
    width: min(4.6875vh, 48px);
    height: min(4.6875vh, 48px);
    border-radius: 50%;
    background: rgba(60, 60, 67, 0.3);
    line-height: min(4.6875vh, 48px);
    text-align: center;
    font-weight: 600;
    font-size: min(2.34375vh, 24px);

    &_selected {
      background: #FFFFFF;
      box-shadow: 0px 33px 38px rgba(0, 0, 0, 0.0314074), 0px 12px 12px rgba(0, 0, 0, 0.05), 0px 3px 3px rgba(0, 0, 0, 0.08);
    }
  }
}
</style>
